<template lang="pug">
#modal-editar-cadastrar-representante
    el-dialog(
        v-loading="isBuscando"
        loading-text="Buscando informações"
        width='700px',
        class='modal-overflow'
        :title="`${editar ? $t('mensagens.comuns.editar') : $t('mensagens.comuns.cadastrar')} ${$t('mensagens.pessoas.produtor')}`"
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        el-form(label-position='top')
            el-form-item
                template(slot='label')
                    span {{ $t('mensagens.pessoas.documento') }} ({{ tipoDocumento.nome === "RUC" ? 'RUC/CI' : tipoDocumento.nome }})
                    span.invalido(v-if='$v.documento.$invalid') *
                    span.invalido(v-else-if='!documentoValido') &nbsp;{{ $t('mensagens.pessoas.documentoInvalido') }}

                .brasil(v-if='tipoDocumento.nome === "CPF/CNPJ"')
                    el-input.w-100(
                        v-model='documento',
                        readonly
                        :disabled='editar',
                    )
                
                .paraguai(v-if='tipoDocumento.nome === "RUC"')
                    el-input.w-100(
                        v-model='documento',
                        :placeholder="$t('mensagens.pessoas.numeroRuc')",
                        :disabled='editar',
                        v-mask='["#######-#", "########-#"]'
                        @blur="onDocumentoBlur"
                    )

            el-form-item
                template(slot='label')
                    span {{ $t('mensagens.pessoas.nomeRazaoSocial') }}
                    span.invalido(v-if='$v.nomeRazaoSocial.$invalid') *

                el-input.w-100(
                    v-model='nomeRazaoSocial',
                    maxlength='50',
                    :placeholder="$t('mensagens.pessoas.nomeRazaoSocial')"
                    :disabled='nomeDisabled'
                )

            el-form-item(v-if='editar && fPL1182CodigoLyraPessoa')
                template(slot='label')
                    span {{ $t('mensagens.pessoas.codigoLyra') }}

                el-input.w-100(
                    v-model='dadosRepresentante.codigoLyra',
                    :disabled='true'
                )

            el-form-item
                el-form-item
                    span {{ $t('mensagens.pessoas.numeroCelular') }}
                    input.w-100.el-input__inner.phone-input(v-model='telefone', type='text', id='telefone', ref='telefone',
                        @input="maskPhoneNumber('telefone')", placeholder="Ex: 971123456",
                        maxlength='40',
                        :class="{'phone-error-border': telefoneError }")
                    span.phone-message(v-if='!telefoneError') {{ $t('mensagens.pessoas.insiraApenasNumeros') }}
                    span.phone-message.text-danger(v-else) {{ $t('mensagens.pessoas.numeroTelefoneInvalido') }}

                p.extra-phone(v-if='!mostrarTelefoneAdicional' @click="mostrarTelefoneAdicional = true") {{ $t('mensagens.pessoas.adicionarTelefoneExtra') }}

                div(v-show='mostrarTelefoneAdicional')
                    span {{ $t('mensagens.pessoas.numeroCelularAdicional') }}
                    input.w-100.el-input__inner.phone-input(v-model='telefoneAdicional', type='text', id='telefoneAdicional', ref='telefoneAdicional',
                        @input="maskPhoneNumber('telefoneAdicional')",placeholder="Ex: 971123456",
                        maxlength='40',
                        :class="{'phone-error-border': telefoneAdicionalError }")
                    span.phone-message(v-if='!telefoneAdicionalError')  {{ $t('mensagens.pessoas.insiraApenasNumeros') }}
                    span.phone-message.text-danger(v-else) {{ $t('mensagens.pessoas.numeroTelefoneInvalido') }}

                div
                    span.section-title-info-cadastro {{ $t('mensagens.pessoas.tituloUploadProdutor') }}
                        UploadDocumentos(
                        v-for="documento in documentos"
                        :key="documento.id"
                        class="upload-documentos"
                        :class="documento.id === 6 ? 'm-0' : ''"
                        :tipoDocumento="documento"
                        :cadastroEdicaoPessoas="cadastroEdicaoPessoas"
                        :arquivosExistentes="dadosRepresentante.arquivos"
                        @update-file-list="handleFileListUpdate"
                        )

        footer.espaco(slot='footer')
            el-button(type='default', @click='fechar') {{ $t('mensagens.comuns.cancelar') }}

            el-button(
                type='primary',
                :disabled='$v.nomeRazaoSocial.$invalid || !documentoValido || telefoneError || telefoneAdicionalError',
                @click='salvar'
            ) {{ $t('mensagens.comuns.salvar') }}

    ModalAtalhoTerritorioParaguai(
        :mostrar='mostrarModalRedirecionamentoTerritorio',
        @fechar='fecharModalAtalhoTerritorio'
    )
</template>

<script>
import RepresentanteService from '@/services/RepresentanteService';

import formatters from '@/utils/formatters';
import validators from '@/utils/validators';

import { required } from 'vuelidate/lib/validators';

import ModalAtalhoTerritorioParaguai from '@/components/ModalAtalhoTerritorioParaguai.vue';
import { mapActions } from 'vuex';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import pt from 'intl-tel-input/build/js/i18n/pt';
import en from 'intl-tel-input/build/js/i18n/en';
import es from 'intl-tel-input/build/js/i18n/es';

import RepresentanteArquivo from '@/services/RepresentanteArquivo.js';
import { get } from 'lodash';
import { formatFlag } from '@/utils/featureFlags/featureFlag';
import { FeatureFlagConst } from '@/constants/FeatureFlag';

import UploadDocumentos from '@/components/territorio/UploadDocumentos';

export default {
    name: 'ModalEditarCadastrarRepresentanteParaguai',
    components: {
        ModalAtalhoTerritorioParaguai,
        UploadDocumentos
    },
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        editar: {
            type: Boolean,
            required: false,
            default: false
        },

        dadosRepresentante: {
            type: Object,
            required: false,
            default: null
        },

        isVincularPessoaParaguai: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            pais: '',
            nomeRazaoSocial: '',
            documento: '',
            telefone: '',
            telefoneAdicional: '',
            mostrarModalRedirecionamentoTerritorio: false,
            tiposDocumento: [],
            tiposProduto: [ { chave: 'DIRETO', descricao: this.$t('mensagens.pessoas.direto') }, { chave: 'INDIRETO', descricao: this.$t('mensagens.pessoas.indireto') } ],
            simNao: [ { chave: 'sim', descricao: this.$t('mensagens.comuns.sim'), value: true }, { chave: 'nao', descricao: this.$t('mensagens.comuns.nao'), value: false } ],
            tipoDocumento: {
                id: 2,
                nome: 'RUC',
                siglaPais: 'PY'
            },
            ruc: '',
            rucDv: '',
            itiTelefone: {},
            itiTelefoneAdicional: {},
            mostrarTelefoneAdicional: false,
            telefoneError: false,
            telefoneAdicionalError: false,
            i18nMap: {
                'pt-BR': pt,
                'en': en,
                'es': es
            },
            fileListPerType: {
                1: [],
                2: [],
                3: [],
                0: []
            },
            documentos: [],
            cadastroEdicaoPessoas: true,
            arquivos: [],
            fPL1182CodigoLyraPessoa: this.$unleash.isEnabled(formatFlag(FeatureFlagConst.FF1182_CODIGO_LYRA_PESSOAS)),
            isBuscando: false,
            nomeDisabled: false
        };
    },

    computed: {
        documentoValido() {
            if (!this.documento) return false;

            if (this.tipoDocumento.nome === 'RUC') return validators.validarDocumento(this.documento, 'RUC');

            return validators.validarDocumento(this.documento);
        }
    },

    mounted() {
        this.buscarTipoArquivos();
    },

    validations: {
        pais: {
            required
        },
        nomeRazaoSocial: {
            required
        },
        documento: {
            required
        },

        representante: ['pais', 'nomeRazaoSocial', 'documento']
    },

    watch: {
        mostrar(newValue) {
            if (Object.keys(this.dadosRepresentante).length > 0) {
                this.nomeRazaoSocial = this.dadosRepresentante.nomeRazaoSocial;
                this.documento = this.dadosRepresentante.cpfCnpj;
                this.tipoDocumento = {
                    id: this.dadosRepresentante.tipoDocumento.id,
                    nome: this.dadosRepresentante.tipoDocumento.nome,
                    siglaPais: this.dadosRepresentante.tipoDocumento.siglaPais
                };
                this.telefone = this.getPhoneNumber(this.dadosRepresentante.telefone);
                this.telefoneAdicional = this.getPhoneNumber(this.dadosRepresentante.telefoneAdicional);
                this.arquivos = this.dadosRepresentante.arquivos;
            } else {
                this.documento = '';
                this.arquivos = [];
            }

            if (newValue) {
                this.initializeIntTel('telefone', 'itiTelefone');
                this.initializeIntTel('telefoneAdicional', 'itiTelefoneAdicional');
            }
            if (this.telefoneAdicional) {
                this.mostrarTelefoneAdicional = true;
            }
        }
    },

    methods: {
        ...mapActions(['setRepresentante']),

        fechar() {
            this.nomeRazaoSocial = '';
            this.documento = '';
            this.tipoDocumento = {
                id: 2,
                nome: 'RUC',
                siglaPais: 'PY'
            };
            this.telefone = '';
            this.telefoneAdicional = '';
            this.mostrarTelefoneAdicional = false;
            this.telefoneError = false;
            this.telefoneAdicionalError = false;
            this.arquivos = [];
            this.nomeDisabled = false;

            this.$emit('fechar');
        },

        fecharModalAtalhoTerritorio() {
            this.nomeRazaoSocial = '';
            this.documento = '';
            this.tipoDocumento = {
                id: 2,
                nome: 'RUC',
                siglaPais: 'PY'
            };
            this.telefone = '';
            this.telefoneAdicional = '';
            this.mostrarTelefoneAdicional = false;
            this.telefoneError = false;
            this.telefoneAdicionalError = false;
            this.mostrarModalRedirecionamentoTerritorio = false;
            this.arquivos = [];
            this.nomeDisabled = false;
        },

        atualizarListaRepresentantes() {
            this.$emit('atualizarListaRepresentantes');
        },

        salvar() {
            this.editar
                ? this.editarRepresentante()
                : this.cadastrarRepresentante();
        },

        async editarRepresentante() {
            if (!this.validarUploadArquivo()) {
                return;
            }
            try {
                if (this.telefoneAdicional && !this.telefone) {
                    this.$notify.warning({
                        message: this.$t('mensagens.pessoas.necessarioTelefonePrincipal')
                    });
                    return;
                }
                await RepresentanteService.editarRepresentante({
                    id: this.dadosRepresentante.id,
                    nomeRazaoSocial: this.nomeRazaoSocial,
                    cpfCnpj: formatters.documentoFormatToNumeral(this.documento),
                    tipoDocumento: {
                        id: this.tipoDocumento.id
                    },
                    telefone: this.getPhoneWithDDIAndIso2(this.telefone, this.itiTelefone),
                    telefoneAdicional: this.getPhoneWithDDIAndIso2(this.telefoneAdicional, this.itiTelefoneAdicional),
                    arquivos: this.arquivos
                });

                this.fechar();
                this.atualizarListaRepresentantes();

                this.$notify.success({
                    message: this.$t('mensagens.pessoas.pessoaEditadaComSucesso')
                });
            } catch (e) {
                if (e.response.status === 400) {
                    this.$notify.warning({
                        message: this.$t(e.response.data.message)
                    });
                } else {
                    this.$notify.error({
                        message: this.$t('mensagens.comuns.erros.inesperadoServidor')
                    });
                }
            }
        },

        redirecionarTerritorio() {
            this.mostrarModalRedirecionamentoTerritorio = true;
        },

        async cadastrarRepresentante() {
            if (!this.validarUploadArquivo()) {
                return;
            }
            try {
                if (this.telefoneAdicional && !this.telefone) {
                    this.$notify.warning({
                        message: this.$t('mensagens.pessoas.necessarioTelefonePrincipal')
                    });
                    return;
                }
                const { data } =
                    await RepresentanteService.cadastrarRepresentante({
                        nomeRazaoSocial: this.nomeRazaoSocial,
                        cpfCnpj: formatters.documentoFormatToNumeral(
                            this.documento
                        ),
                        tipoDocumento: {
                            id: this.tipoDocumento.id,
                            siglaPais: this.tipoDocumento.siglaPais
                        },
                        telefone: this.getPhoneWithDDIAndIso2(this.telefone, this.itiTelefone),
                        telefoneAdicional: this.getPhoneWithDDIAndIso2(this.telefoneAdicional, this.itiTelefoneAdicional),
                        arquivos: this.arquivos
                    });

                this.setRepresentante(data);

                this.fechar();
                this.atualizarListaRepresentantes();

                this.$notify.success({
                    message: this.$t('mensagens.pessoas.pessoaAdicionadaComSucesso')
                });

                if (!this.isVincularPessoaParaguai) {
                    this.redirecionarTerritorio();
                }
            } catch (e) {
                if (e.response.status === 400) {
                    this.$notify.warning({
                        message: this.$t(e.response.data.message)
                    });
                } else {
                    this.$notify.error({
                        message: this.$t('mensagens.comuns.erros.inesperadoServidor')
                    });
                }
            }
        },

        initializeIntTel(component, itiVariable) {
            this.$nextTick(() => {
                const input = this.$refs[component];
                if (input) {
                    this[itiVariable] = intlTelInput(input, {
                        containerClass: 'w-100',
                        initialCountry: this.tipoDocumento.siglaPais,
                        i18n: this.i18nMap[this.$i18n.locale]
                    });
                }
                if (this.editar && this.dadosRepresentante[component]) {
                    const country = this.getCountry(this[itiVariable], this.dadosRepresentante[component]);
                    this[itiVariable].setCountry(country.iso2);
                }
            });
        },

        maskPhoneNumber(key) {
            let input = this[key].replace(/\D/g, '');
            let errorKey = key + 'Error';

            if (input.length > 10) {
                input = input.substring(0, 10);
            }

            if (input.length > 0) {
                input = input.replace(/^(\d{0,4})/, '$1');
            }

            if (input.length > 4) {
                input = input.replace(/^(\d{4})(\d{0,3})/, '$1 $2');
            }

            if (input.length > 8) {
                input = input.replace(/^(\d{4} \d{3})(\d{0,3})$/, '$1-$2');
            }

            if (input.length !== 12 && input.length !== 0) {
                this[errorKey] = true;
            } else {
                this[errorKey] = false;
            }

            this[key] = input;
        },

        getPhoneWithDDIAndIso2(phoneNumber, iti) {
            if (phoneNumber && iti.getSelectedCountryData().dialCode && iti.getSelectedCountryData().iso2 && iti) {
                return `${iti.getSelectedCountryData().iso2} +${iti.getSelectedCountryData().dialCode} ${phoneNumber}`;
            } else {
                return '';
            }
        },

        getPhoneNumber(intPhone) {
            if (!intPhone) return '';
            const phoneWithoutCountryCode = intPhone.slice(2).trim();
            return phoneWithoutCountryCode.replace(/^\+\d{1,3}\s?/, '');
        },

        getCountry(iti, phoneNumber) {
            const iso2 = phoneNumber.slice(0, 2).trim();
            return iti.countries.find(x => x.iso2 === iso2);
        },

        async buscarTipoArquivos() {
            try {
                    const { data } = await RepresentanteArquivo.findTipoArquivos();
                    this.documentos = data;
                } catch (error) {
                    this.$notify.error({
                        message: get(error, 'response.data.message', error.message)
                    });
                }
        },

        handleFileListUpdate({ tipo, fileList }) {
            this.$set(this.fileListPerType, tipo, fileList);

            let lista = Object.values(this.fileListPerType)
                .flat()
                .map(item => {
                    const { idTipoArquivo, ...resto } = item;
                    return {
                        nomeArquivo: resto.name,
                        idTipoArquivo
                    };
                });

            if (fileList.length === 0) {
                this.arquivos = this.arquivos.filter(
                    arquivo => arquivo.idTipoArquivo !== tipo.id
                );
            } else {
                this.arquivos = this.arquivos.filter(
                    arquivo => arquivo.idTipoArquivo !== tipo.id
                );

                this.arquivos.push(...lista);
                this.fileListPerType = {};
            }
        },

        validarUploadArquivo() {
            // limpando requiredIds para retirar obrigatoriedade de documentos
            const requiredIds = [];

            const idsPresentes = this.arquivos
            .filter(arquivo => requiredIds.includes(arquivo.idTipoArquivo))
            .map(arquivo => arquivo.idTipoArquivo);

            const validaUploadArquivo = requiredIds.every(id => idsPresentes.includes(id));

            if (!validaUploadArquivo) {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.notificacao.campoObrigatorioUpload')
                });
                return false;
            } else {
                return true;
            }
        },

        async onDocumentoBlur() {
            if (!this.documentoValido) return;
                this.isBuscando = true;
            try {
                const raw = formatters.documentoFormatToNumeral(this.documento);
                const filtro = {};
                filtro.documento = raw;
                const { status, data } = await RepresentanteService.buscarPorDocumento(filtro);
                if (status === 200 && data) {
                    this.nomeRazaoSocial = data.nomeRazaoSocial;
                    this.nomeDisabled = true;
                    this.telefone = this.getPhoneNumber(data.telefone);
                    this.telefoneAdicional = this.getPhoneNumber(data.telefoneAdicional);
                    if (data.telefoneAdicional !== '') {
                        this.mostrarTelefoneAdicional = true;
                    }
                }
            } catch (e) {
                this.$notify.error({
                    message: this.$t('mensagens.comuns.erros.inesperadoServidor')
                });
            } finally {
                this.isBuscando = false;
            }
        }
    }
};
</script>

<style lang="scss">
#modal-editar-cadastrar-representante {
    footer {
        display: flex;
        justify-content: space-between;
    }

    .invalido {
        color: var(--danger);
    }

    .espaco {
        display: flex;
    }

    .el-form-item .el-form-item__label {
        font-weight: normal !important;
    }

    .iti {
        --iti-path-flags-1x: url('../../node_modules/intl-tel-input/build/img/flags.webp');
        --iti-path-flags-2x: url('../../node_modules/intl-tel-input/build/img/flags@2x.webp');
        --iti-path-globe-1x: url('../../node_modules/intl-tel-input/build/img/globe.webp');
        --iti-path-globe-2x: url('../../node_modules/intl-tel-input/build/img/globe@2x.webp');
    }

    .phone-input {
        padding-left: 50px;
    }

    .phone-error-border {
        border: 1px solid var(--danger) !important;
    }

    .phone-message {
        margin-left: 50px;
        font-size: 12px;
    }

    .extra-phone {
        color: var(--primary);
        font-weight: 500;
        cursor: pointer;
    }

    .upload-documentos {
        border-radius: 5px;
        border: 1px solid var(--default-border-color);
    }

    .modal-overflow > div.el-dialog {
        height: 800px;
        overflow: auto;
    }
}
</style>
